import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit, TemplateRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { Subscription } from 'rxjs';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Router } from '@angular/router';
import { CdkDragStart, moveItemInArray, CdkDragDrop } from '@angular/cdk/drag-drop';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { ContactVm, FilteredContactVm, UpdateColumnContactVm }
  from 'src/app/viewModels/core/contacts-vm';
import { ContactsService } from '../../services/coreService/contacts.service';
import { ModuleName } from '../../services/coreService/contact.enum';
import { PaycheckErrorComponent } from 'src/app/middleware/common/paycheckError/paycheckError.component';


@Component({
  selector: 'app-contact-listing',
  templateUrl: './contact-listing.component.html',
  styleUrls: ['./contact-listing.component.scss'],
  providers: [DatePipe],
})
export class ContactListingComponent implements OnInit {
  currentUser: any;
  showPCC: boolean = false;
  OfficeIDList: any = [];
  databaseId: string;
  organizationId: string;
  responseHolder: any;
  contactList: any[] = [];
  Allids: any[] = [];
  isAnyRecordAvailable: boolean = false;
  contactFieldList: any[] = [];
  contactFieldListNew: any[] = [];
  contactFieldColumnToogle: any[] = [];
  ToogleColumnFields: any[] = [];
  contactListNew: any[] = [];
  addListing: boolean = false;
  value = '';
  clickEventsubscription: Subscription;
  clickEventsubscription1: Subscription;
  clickEventsubscription2: Subscription;
  contactUserListReceived = false;
  contactListReceived = false;

  displayedColumns: string[] = [];
  dataSource: any;

  _returnList: any[] = [];
  _returnColumns: any[] = [];
  clmshow: boolean = false;

  contactFilterNameList: any[] = [];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  previousIndex: number;
  closelist: boolean = false;
  showFilter: boolean = false;
  showSearch: boolean = false;
  showDetail: boolean = false;
  showSavedFilter: boolean = false;
  globalSort: Sort;
  filterText: any;
  targetList: any;
  filteredList: any;
  totalCount: any;
  paginatorTotalLength: any;
  dataCount: any;
  currentData: any;
  pageModelData = {
    pageIndex: 0,
    pageSize: 20,
    searchValue: '',
  };

  contactfilterData = {
    userID: '',
    organizationID: 0,
    databaseID: 0,
    folderID: 0,
    officeID: 0,
    OfficeIDList: [],
  };
  pageIndex: any;
  pageSize: any;
  SendFilteredNameFromContact: string = "";

  // FilteredfieldsModel = {
  //   filterFieldID: 0,
  //   filterFieldValue: "",
  //   childFieldTyp: 0
  // };

  FilteredfieldsRequestModel: any[] = [];
  FiltersCompanyDataList: any[] = [];

  Filtername: string = '';
  fieldFolderType: any;
  selectedfilterList: any[] = [];
  selectedtransactionId: number = 0;
  closeFilterPanel: string = '';

  deleteContactModel = {
    contactID: [],
    userID: '',
    databaseID: 0,
    organizationID: 0,
    folderID: 0,
    officeID: 0,
    OfficeIDList: []
  };

  FavoriteContactModel = {
    contactID: [],
    userID: '',
    databaseID: 0,
    organizationID: 0,
    officeID: 0
  };

  Module: string = "";
  permissionAsssign: any[] = [];
  folderListPermission: any[] = [];
  folderList: any[] = [];

  getUserPreferencesModel = {
    userID: '',
    organizationID: 0
  }

  addUserPreferencesModel = {
    userPreferenceID: 0,
    key: '',
    value: '',
    userID: '',
    createdBy: '',
    OfficeIDList: [],
    officeID: 0
  }

  folderID: any;
  columnData: any[] = [];
  myOfficeID: any;
  associatedAPIs: any = [] = [];
  showPaycheck: boolean = false;
  payChekSubmittedResult: any;
  isReCreate: boolean = false;

  constructor(private dialog: MatDialog, private statusConst: StatusConstant, private loaderService: LoaderService,
    private contactService: ContactsService, private toastr: ToastrService, private contactVm: ContactVm,
    private filteredContactVm: FilteredContactVm, private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private _dataSharingService: DataSharingService, public _ChangeDetectorRef: ChangeDetectorRef, private router: Router,
    private updateColumnContactVm: UpdateColumnContactVm, public datepipe: DatePipe, private cdr: ChangeDetectorRef) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }


  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    this.clickEventsubscription.unsubscribe();
  }

  ngOnInit(): void {
    sessionStorage.setItem('edashboard', "false");
    this.permissionAsssign = JSON.parse(sessionStorage.getItem("menuModules"));
    this.permissionAsssign = this.permissionAsssign.filter((x) => x.mainModuleName == ModuleName.Contact && x.isAssign == true);
    if (this.permissionAsssign.length == 0) {
      this.router.navigate(['unauthorised']);
      return;
    }

    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module = [];
    Module = menuModulesList.filter(x => x.mainModuleName == ModuleName.Contact);
    if (Module.length > 0) {
      this.Module = Module[0].orgModuleName;
      this.folderID = Module[0].folderID;
    }

    this.associatedAPIs = JSON.parse(sessionStorage.getItem("associatedAPIs"));
    if (this.associatedAPIs.length > 0) {
      var checkPayCheck = [];
      var checkPCC = [];

      checkPayCheck = this.associatedAPIs.filter(x => x.apiName == 'Paychex' && x.isContactMapped == true);
      if (checkPayCheck.length > 0) {
        this.showPaycheck = true;
      } else {
        this.showPaycheck = false;
      }

      checkPCC = this.associatedAPIs.filter(x => x.apiName == 'PointClickCare' && x.isContactMapped == true);
      if (checkPCC.length > 0) {
        this.showPCC = true;
      } else {
        this.showPCC = false;
      }
    }

    this.FilteredfieldsRequestModel = [];
    sessionStorage.setItem('HeaderModuleName', this.Module);
    this._dataSharingService.sendSelectedModuleName(this.Module);
    this.clickEventsubscription = this._dataSharingService.getSaveUserForContact().subscribe(() => {
      this.getList("");
    });

    this.getAllCoreTypeNameFilter();
    this.clmshow = false;
    this._dataSharingService.sendShowFormsSiderbar(this.Module);
    this.cdr.detectChanges();
  }

  clearAllApplyFilter(result) {
    this.Filtername = "All " + this.Module;
    //this.getAllCoreTypeNameFilter();
    this.getCloseFilter(false);
    this.FilteredfieldsRequestModel = [];
    this.getList("");
    this.clmshow = false;
    this.cdr.detectChanges();
  }

  GetExport(result) {
    this.getList("");
  }

  DeleteSelectedRecordForCore(result) {
    if (result.length > 0 && result != "" && result != undefined) {
      this.deleteContactModel.userID = this.currentUser.UID;
      this.deleteContactModel.folderID = this.folderID;//20;
      this.deleteContactModel.databaseID = Number(this.databaseId);
      this.deleteContactModel.organizationID = Number(this.organizationId);
      this.deleteContactModel.contactID = result;
      this.deleteContactModel.officeID = this.myOfficeID;
      this.deleteContactModel.OfficeIDList = this.OfficeIDList;
      this.contactService.DeleteContactTransaction(this.deleteContactModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            this.getList("");
            this.toastr.success('Record delete successfully.', '', {
              timeOut: 3000,
            });
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }


  ArchiveSelectedRecordForContact(result) {
    if (result.length > 0 && result != "" && result != undefined) {
      var ReqModel = {
        iDs: result,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        databaseID: Number(this.databaseId)
      }
      this.contactService.setContactArchive(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            this.getList("");
            this.toastr.success('Record Archived successfully.', '', {
              timeOut: 3000,
            });
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }

  ActivateSelectedRecordForContact(result) {
    if (result.length > 0 && result != "" && result != undefined) {
      var ReqModel = {
        iDs: result,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        databaseID: Number(this.databaseId)
      }
      this.contactService.setContactActivate(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            this.getList("");
            this.toastr.success('Record activated successfully.', '', {
              timeOut: 3000,
            });
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }

  FavoriteSelectedRecordAddForCore(result) {
    if (result.length > 0 && result != "" && result != undefined) {
      this.FavoriteContactModel.userID = this.currentUser.UID;
      this.FavoriteContactModel.databaseID = Number(this.databaseId);
      this.FavoriteContactModel.organizationID = Number(this.organizationId);
      this.FavoriteContactModel.contactID = result;
      this.FavoriteContactModel.officeID = this.myOfficeID;
      this.contactService.FavoriteContactTransaction(this.FavoriteContactModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            this.getList("");
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }

  FavoriteSelectedRecordForDeleteCore(result) {
    if (result.length > 0 && result != "" && result != undefined) {
      this.FavoriteContactModel.userID = this.currentUser.UID;
      this.FavoriteContactModel.databaseID = Number(this.databaseId);
      this.FavoriteContactModel.organizationID = Number(this.organizationId);
      this.FavoriteContactModel.contactID = result;
      this.FavoriteContactModel.officeID = this.myOfficeID;
      this.contactService.FavoriteDeleteContactTransaction(this.FavoriteContactModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            if (this.Filtername == "Starred") {
              this.getFavoriteCoreList("");
            }
            else {
              this.getList("");
            }
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }


  FilteredList(result) {
    var chckdata = [];
    chckdata = result.filterFieldModels;
    if (chckdata != undefined) {
      result = result.filterFieldModels;
    }
    if (result.length > 0 && result != "" && result != undefined) {
      this.FilteredfieldsRequestModel = [];
      this.selectedfilterList = result;
      for (let i = 0; i < this.selectedfilterList.length; i++) {
        let getdate;
        var filterValue = "";
        if (this.selectedfilterList[i].filterValue == "Today") {
          getdate = [moment(), moment()];
          filterValue = (moment(getdate[0]).format("MM/DD/YYYY") + ',' + moment(getdate[1]).format("MM/DD/YYYY"));
        }
        else if (this.selectedfilterList[i].filterValue == "This Week") {
          getdate = [moment().startOf('week'), moment().endOf('week')];
          filterValue = (moment(getdate[0]).format("MM/DD/YYYY") + ',' + moment(getdate[1]).format("MM/DD/YYYY"));
        }
        else if (this.selectedfilterList[i].filterValue == "Last Week") {
          getdate = [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')];
          filterValue = (moment(getdate[0]).format("MM/DD/YYYY") + ',' + moment(getdate[1]).format("MM/DD/YYYY"));
        }
        else if (this.selectedfilterList[i].filterValue == "This Month") {
          getdate = [moment().startOf('month'), moment().endOf('month')];
          filterValue = (moment(getdate[0]).format("MM/DD/YYYY") + ',' + moment(getdate[1]).format("MM/DD/YYYY"));
        }
        else if (this.selectedfilterList[i].filterValue == "Last Month") {
          getdate = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
          filterValue = (moment(getdate[0]).format("MM/DD/YYYY") + ',' + moment(getdate[1]).format("MM/DD/YYYY"));
        }
        else {
          filterValue = this.selectedfilterList[i].filterValue;
        }

        var filterFieldsRequestModel = {
          filterFieldID: this.selectedfilterList[i].fieldID,
          filterFieldValue: filterValue,
          childFieldType: this.selectedfilterList[i].childFieldType
        }
        this.FilteredfieldsRequestModel.push(filterFieldsRequestModel);
      }

      this.filteredContactVm.PageIndex = this.pageModelData.pageIndex;
      this.filteredContactVm.PageSize = this.pageModelData.pageSize;
      this.filteredContactVm.UserID = this.currentUser.UID;
      this.filteredContactVm.FolderId = this.folderID;//;
      this.filteredContactVm.DatabaseID = Number(this.databaseId);
      this.filteredContactVm.OrganizationID = Number(this.organizationId);
      this.filteredContactVm.fields = this.FilteredfieldsRequestModel;
      this.filteredContactVm.userContactID = Number(sessionStorage.getItem('userContactID'));
      this.filteredContactVm.roleIDList = sessionStorage.getItem('roleIDList').split(',');
      this.filteredContactVm.officeIDList = this.OfficeIDList;
      this.filteredContactVm.officeID = this.myOfficeID;
      this.loaderService.show();
      this.contactService.getFilteredContactsList(this.filteredContactVm).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.totalCount = response.data.totalcount;
            this.contactList = response.data.contacts;//transactions;
            sessionStorage.setItem('contactList', JSON.stringify(response.data.contacts));
            this.Allids = response.data.ids;
            this.contactList.map((e) => {
              var data = [];
              data = e.fields.filter((element) => element.fieldName == 'Image');
              if (data.length > 0) {
                let imagepath = data[0].fieldValue;
                if (imagepath != '') {
                  if (imagepath.substring(0, 4) == 'http') {
                    e.fields.forEach((element) => {
                      if (element.fieldName == 'Name') {
                        element.fieldValue = element.fieldValue + ',' + imagepath;
                      }
                    });
                  }
                }
              }
              return e;
            });

            this.contactUserListReceived = true;
            let temGridFinalArray = response.data.gridUserSettings.filter((x) => x.fieldName == 'Name');
            let tempgridsettingWithoutName = response.data.gridUserSettings.filter((x) => x.fieldName != 'Name');
            tempgridsettingWithoutName.forEach((element) => {
              temGridFinalArray.push(element);
            });
            response.data.gridUserSettings = temGridFinalArray;
            this.contactFieldList = response.data.gridUserSettings;
            this.contactFieldList = this.contactFieldList.filter((s) => s.isDisplay == true && s.fieldName != 'Image');

            this.contactListReceived = true;
            this.setListToDisplay();
            this.loaderService.hide();
          } else {
            this.loaderService.hide();
            this.contactList = [];
            this.contactFieldList = [];
            this._returnList = [];
            this.dataSource = new MatTableDataSource();
            this.dataSource.data = [];
            this.dataSource.paginator = null;
            this.dataSource.sort = this.sort;
            this.paginatorTotalLength = 0;
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
    else {
      this.Filtername = "All " + this.Module;
      this.FilteredfieldsRequestModel = [];
      this.getList("");
      this.getAllCoreTypeNameFilter();
      this.clmshow = false;
      this.cdr.detectChanges();
    }
  }



  OnFilterNameClick(filter) {
    var filterId = 0;

    var selectedfilterId = filter.filterID;
    this.Filtername = filter.filterName;
    if (filter.filterID == 0) {
      if (filter.filterName == "All " + this.Module) {
        this.loaderService.hide();
        this.FilteredfieldsRequestModel = [];
        this.selectedfilterList = [];
        this.SendFilteredNameFromContact = this.Filtername;
        this.getList("");
        filterId = 0;
        this.AddPrefrences(filterId, "ContactRecentFilter")
        return;
      }
      if (filter.filterName == "Recent") {
        if (this.checkRecentFilter.length > 0) {
          var RecentFilter = this.FiltersCompanyDataList.filter(x => x.filterID === Number(this.checkRecentFilter[0].value));
          if (RecentFilter[0].filterName == "All " + this.Module) {
            this.getList("");
            this.Filtername = "All " + this.Module;
            return;
          }
          else if (RecentFilter[0].filterName == "Starred") {
            this.getFavoriteCoreList("");
            this.Filtername = "Starred";
            return;
          }
          else if (RecentFilter[0].filterName != "Starred" && RecentFilter[0].filterName != "All " + this.Module) {
            this.FilteredList(RecentFilter[0].filterFieldModels);
            this.Filtername = RecentFilter[0].filterName;
            return;
          }

        }
        else {
          this.Filtername;
        }
      }
    }
    else if (filter.filterID == -1) {
      if (filter.filterName == "Starred") {
        this.Filtername = "Starred";
        this.getFavoriteCoreList("");
        filterId = -1;
        this.AddPrefrences(filterId, "ContactRecentFilter");
        return;
      }
    }
    else {
      this.FilteredfieldsRequestModel = [];
      this.selectedfilterList = filter;//filter.filterFieldModels;
      this.SendFilteredNameFromContact = this.Filtername;
      this.FilteredList(this.selectedfilterList);
      this.AddPrefrences(selectedfilterId, "ContactRecentFilter");
    }
  }

  archieved: boolean = false;

  ShowArchivedFilter() {
    this.archieved = true;
    this.getList("");
  }

  AddPrefrences(filterId, key) {
    this.addUserPreferencesModel.userPreferenceID = 0;
    this.addUserPreferencesModel.key = key;
    this.addUserPreferencesModel.value = filterId.toString();
    this.addUserPreferencesModel.userID = this.currentUser.UID;
    this.addUserPreferencesModel.createdBy = this.currentUser.UID;
    this.addUserPreferencesModel.officeID = this.myOfficeID;
    this.addUserPreferencesModel.OfficeIDList = this.OfficeIDList;
    this.contactService.AddPrefrences(this.addUserPreferencesModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  paycheckErrorList: any = [] = [];

  SendtoPaychexRecordForContact(result) {
    this.payChekSubmittedResult = result;
    if (result.length > 0 && result != "" && result != undefined) {

      var contactListForPaychex = [];
      var thirdPartyApiID = 0;
      var officeThirdPartyApiID = 0;

      if (this.associatedAPIs.find(x => x.apiName == 'Paychex' && x.isContactMapped == true)) {
        thirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'Paychex' && x.isContactMapped == true).thirdPartyApiID;
        officeThirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'Paychex' && x.isContactMapped == true).officeThirdPartyApiID;
      }

      for (let i = 0; i < result.length; i++) {
        var obj = {
          contactID: result[i].selectedRecord,
          subFolderID: result[i].subFolderID,
        }
        contactListForPaychex.push(obj);
      }
      var ReqModel = {
        contactList: contactListForPaychex,
        folderID: this.folderID,
        thirdPartyApiID: thirdPartyApiID,
        officeThirdPartyApiID: officeThirdPartyApiID,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        isrecreate: this.isReCreate
      }
      // return;   
      this.loaderService.show();
      this.contactService.sendToPaychex(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.isReCreate = false;
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            var check = [];
            var checkError = [];
            check = this.responseHolder.data.response;
            if (check.length > 0) {
              checkError = check.filter(x => x.status != this.statusConst.statusSuccess);
              if (checkError.length == 0) {
                this.getList("");
                this.toastr.success('Record added in Paychex successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                let list = []
                let name = "";
                list = result.filter(x => x.selectedRecord == Number(checkError[0].data.content[0].employeeId));
                if (list.length > 0) {
                  name = list[0].name;
                }
                for (var i = 0, len = checkError[0].data.errors.length; i < len; ++i) {

                  //list = result.filter(x=> x.selectedRecord == Number(checkError[i].data.content[0].employeeId));
                  //if(list.length>0){
                  //  name=list[0].name;
                  //}
                  var obj = {
                    name: name,
                    code: checkError[0].data.errors[i].code,
                    description: checkError[0].data.errors[i].description,
                  }
                  this.paycheckErrorList.push(obj);
                }
                this.showPaycheckError();
                this.getList("");
              }
            }
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }

  sendToPCCForContact(result) {
    this.payChekSubmittedResult = result;
    if (result.length > 0 && result != "" && result != undefined) {

      var contactListForPaychex = [];
      var thirdPartyApiID = 0;
      var officeThirdPartyApiID = 0;

      if (this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isContactMapped == true)) {
        thirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isContactMapped == true).thirdPartyApiID;
        officeThirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isContactMapped == true).officeThirdPartyApiID;
      }

      for (let i = 0; i < result.length; i++) {
        var obj = {
          contactID: result[i].selectedRecord,
          subFolderID: result[i].subFolderID,
        }
        contactListForPaychex.push(obj);
      }
      var ReqModel = {
        contactList: contactListForPaychex,
        folderID: this.folderID,
        thirdPartyApiID: thirdPartyApiID,
        officeThirdPartyApiID: officeThirdPartyApiID,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        isrecreate: this.isReCreate
      }
      // return;   
      this.loaderService.show();
      this.contactService.sendToPCC(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.isReCreate = false;
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            var check = [];
            var checkError = [];
            check = this.responseHolder.data.response;
            if (check.length > 0) {
              checkError = check.filter(x => x.status != this.statusConst.statusSuccess);
              if (checkError.length == 0) {
                this.getList("");
                this.toastr.success('Record added in Paychex successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                let list = []
                let name = "";
                list = result.filter(x => x.selectedRecord == Number(checkError[0].data.content[0].employeeId));
                if (list.length > 0) {
                  name = list[0].name;
                }
                for (var i = 0, len = checkError[0].data.errors.length; i < len; ++i) {

                  //list = result.filter(x=> x.selectedRecord == Number(checkError[i].data.content[0].employeeId));
                  //if(list.length>0){
                  //  name=list[0].name;
                  //}
                  var obj = {
                    name: name,
                    code: checkError[0].data.errors[i].code,
                    description: checkError[0].data.errors[i].description,
                  }
                  this.paycheckErrorList.push(obj);
                }
                this.showPaycheckError();
                this.getList("");
              }
            }
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }

  showPaycheckError() {
    const dialogRef = this.dialog.open(PaycheckErrorComponent, {
      data: {
        list: this.paycheckErrorList,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isReCreate = result;
        this.SendtoPaychexRecordForContact(this.payChekSubmittedResult);
      }
    });
  }


  AddFavoriteForFilter(result) {
    this.AddPrefrences(result, "ContactDefaultFilter");
  }

  DeleteFavoriteForFilter(result) {
    this.AddPrefrences("", "ContactDefaultFilter");
  }


  getAllCoreTypeNameFilter() {
    this.contactfilterData.databaseID = Number(this.databaseId);
    this.contactfilterData.organizationID = Number(this.organizationId);
    this.contactfilterData.userID = this.currentUser.UID;
    this.contactfilterData.folderID = this.folderID;//20;
    this.contactfilterData.officeID = this.myOfficeID;
    this.contactfilterData.OfficeIDList = this.OfficeIDList;
    this.contactService.getAllContactTypeFilterList(this.contactfilterData).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.contactFilterNameList = [];
          var newlist = [];
          var AllContact: any;
          var AllFav: any;
          var Recent: any;
          var AllReviewer: any;

          AllContact = {
            filterID: 0,
            filterName: "All " + this.Module,
            folderID: this.folderID,//17,
            isActive: true,
            isDefault: false,
            isFavourite: false,
            organizationID: Number(this.organizationId),
            userID: "",
          }
          AllFav = {
            filterID: -1,
            filterName: "Starred",
            folderID: this.folderID,// 17,
            isActive: true,
            isDefault: false,
            isFavourite: false,
            organizationID: Number(this.organizationId),
            userID: "",
          }
          Recent = {
            filterID: 0,
            filterName: "Recent",
            folderID: this.folderID,//17,
            isActive: true,
            isDefault: false,
            isFavourite: false,
            organizationID: Number(this.organizationId),
            userID: "",
          }
          AllReviewer = {
            filterID: -2,
            filterName: "Review",
            folderID: this.folderID,
            isActive: true,
            isDefault: false,
            isFavourite: false,
            organizationID: Number(this.organizationId),
            userID: "",
          }

          this.contactFilterNameList.push(AllContact);//this.AllCore
          this.contactFilterNameList.push(AllFav);//this.AllFav
          this.contactFilterNameList.push(Recent);//this.Recent
          this.contactFilterNameList.push(AllReviewer);//this.Reviewer

          // this.contactFilterNameList.push(this.AllContact);
          // this.contactFilterNameList.push(this.AllFav);
          // this.contactFilterNameList.push(this.Recent);
          // this.contactFilterNameList.push(this.AllReviewer);//this.Reviewer

          newlist = response.data;
          for (var i = 0, len = newlist.length; i < len; ++i) {
            this.contactFilterNameList.push(newlist[i]);
          }
          if (response.data) {
            this.FiltersCompanyDataList = response.data;
            let localFilters = response.data.map(({ filterName }) => filterName);
            sessionStorage.setItem('localFiltersContact', localFilters);
            this.GetUserPreferences();
          }
        }
        else {
          this.contactFilterNameList = [];
          AllContact = {
            filterID: 0,
            filterName: "All " + this.Module,
            folderID: this.folderID,//17,
            isActive: true,
            isDefault: false,
            isFavourite: false,
            organizationID: Number(this.organizationId),
            userID: "",
          }
          AllFav = {
            filterID: -1,
            filterName: "Starred",
            folderID: this.folderID,// 17,
            isActive: true,
            isDefault: false,
            isFavourite: false,
            organizationID: Number(this.organizationId),
            userID: "",
          }

          this.contactFilterNameList.splice(0, 0, AllContact);
          this.contactFilterNameList.splice(1, 1, AllFav);

          // this.contactFilterNameList.splice(0, 0, this.AllContact);
          // this.contactFilterNameList.splice(1, 1, this.AllFav);
          this.Filtername = "All " + this.Module;
          sessionStorage.setItem('localFiltersContact', "");
          this.GetUserPreferences();
        }
      }
    });
  }

  checkRecentFilter: any[] = [];
  checkDefaultFilter: any[] = [];

  GetUserPreferences() {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.contactService.GetUserPreferences(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.checkRecentFilter = [];
        this.checkDefaultFilter = [];
        this.FiltersCompanyDataList = [];
        this.isAnyRecordAvailable = true;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          var getdata = this.responseHolder.data;

          var AllContact = {
            filterID: 0,
            filterName: "All " + this.Module,
            folderID: this.folderID,//17,
            isActive: true,
            isDefault: false,
            isFavourite: false,
            organizationID: Number(this.organizationId),
            userID: "",
          }
          var AllFav = {
            filterID: -1,
            filterName: "Starred",
            folderID: this.folderID,// 17,
            isActive: true,
            isDefault: false,
            isFavourite: false,
            organizationID: Number(this.organizationId),
            userID: "",
          }

          this.FiltersCompanyDataList.push(AllContact);
          this.FiltersCompanyDataList.push(AllFav);

          // this.FiltersCompanyDataList.push(this.AllContact);
          // this.FiltersCompanyDataList.push(this.AllFav);

          if (getdata) {
            this.checkRecentFilter = getdata.filter(x => x.key === "ContactRecentFilter");
            this.checkDefaultFilter = getdata.filter(x => x.key === "ContactDefaultFilter");

            if (this.checkDefaultFilter.length > 0) {
              for (var user = 0; user < this.contactFilterNameList.length; user++) {
                if (this.contactFilterNameList[user].filterID == Number(this.checkDefaultFilter[0].value)) {
                  this.contactFilterNameList[user].isDefault = true;
                }
                else {
                  this.contactFilterNameList[user].isDefault = false;
                }
              }
            }
            // var check=[];
            // check= this.FiltersCompanyDataList.filter(x => x.isDefault === true);
            // if(check.length>0){
            //   this.contactFilterNameList.find((item) => item.filterID == check[0].filterID).isDefault = check[0].isDefault;            
            // }

            this.contactFilterNameList;
            this.FiltersCompanyDataList;
            if (this.checkRecentFilter.length == 0 && this.checkDefaultFilter.length == 0) {
              this.getList('');
              this.Filtername = "All " + this.Module;
              return;
            }

            else if (this.checkRecentFilter.length > 0 && this.checkDefaultFilter.length > 0) {
              var DefaultFilter = this.contactFilterNameList.filter(x => x.filterID === Number(this.checkDefaultFilter[0].value));

              if (DefaultFilter.length > 0) {
                if (DefaultFilter[0].filterID == "-1") {
                  this.getFavoriteCoreList("");
                  this.Filtername = "Starred";
                }
                else if (DefaultFilter[0].filterID == "0") {
                  this.getList("");
                  this.Filtername = "All " + this.Module;
                }
                else if (DefaultFilter[0].filterID > "0") {
                  this.FilteredList(DefaultFilter[0].filterFieldModels);
                  this.Filtername = DefaultFilter[0].filterName;
                }
              }
              return;
            }

            else if (this.checkRecentFilter.length == 0) {
              var DefaultFilter = this.contactFilterNameList.filter(x => x.filterID === Number(this.checkDefaultFilter[0].value));

              if (DefaultFilter.length > 0) {
                if (DefaultFilter[0].filterID == "-1") {
                  this.getFavoriteCoreList("");
                  this.Filtername = "Starred";
                }
                else if (DefaultFilter[0].filterID == "0") {
                  this.getList("");
                  this.Filtername = "All " + this.Module;
                }
                else if (DefaultFilter[0].filterID > "0") {
                  this.FilteredList(DefaultFilter[0].filterFieldModels);
                  this.Filtername = DefaultFilter[0].filterName;
                }
              }
              return;
            }

            else if (this.checkDefaultFilter.length == 0) {
              var RecentFilter = [];
              RecentFilter = this.contactFilterNameList.filter(x => x.filterID === Number(this.checkRecentFilter[0].value));

              if (RecentFilter.length > 0) {
                if (RecentFilter[0].filterID == "-1") {
                  this.getFavoriteCoreList("");
                  this.Filtername = "Starred";
                }
                else if (RecentFilter[0].filterID == "0") {
                  this.getList("");
                  this.Filtername = "All " + this.Module;
                }
                else if (RecentFilter[0].filterID > "0") {
                  this.FilteredList(RecentFilter[0].filterFieldModels);
                  this.Filtername = RecentFilter[0].filterName;
                }
              }
              else {
                this.getList("");
                this.Filtername = "All " + this.Module;
              }
            }
          } else {
            this.Filtername = "All " + this.Module;
            this.getList("");
          }
        }
        else {
          this.Filtername = "All " + this.Module;
          this.getList("");
        }
      }
    }, (error) => {
      this.Filtername = "All " + this.Module;
      this.getList("");
    }, () => {

    });
  }

  setDisplayedColumns() {
    this.displayedColumns = [];
    this.isAnyRecordAvailable && this.contactFieldList.forEach((colunm, index) => {
      colunm.index = index;
      this.displayedColumns[index] = colunm.fieldName;
    });
  }

  dragStarted(event: CdkDragStart, index: number) {
    this.previousIndex = index;
  }

  dropListDropped(event: CdkDragDrop<string[]>) {
    if (event.currentIndex == 0) return false;
    if (event.previousIndex == 0) return false;

    moveItemInArray(
      this.contactFieldListNew,
      event.previousIndex,
      event.currentIndex
    );

    this.columnData = [];

    for (let index = 1; index < this.contactFieldListNew.length; index++) {
      var req = {
        fieldID: this.contactFieldListNew[index].fieldID,
        viewOrder: index + 0,
        isDisplay: true
      }
      this.columnData.push(req);
    }

    this.setDisplayedColumns();

    var ReqModel = {
      userID: this.currentUser.UID,
      columnData: this.columnData,
      folderID: this.folderID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.contactService.ReorderContactFieldColumnList(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.getList("");
        }
      }
    });
  }

  setListForDrogandDrop(list: any[]): any[] {
    var tempList: any[] = list.map((s) => Object.assign(s));
    let returnList = [];
    var favorite: Boolean = false;
    var paychexID;
    tempList.forEach((element) => {
      let ReqModel = {};
      let coreID = 0;
      let TypeID = 0;
      favorite = element.isFavorite;
      paychexID = element.paychexID;
      element.fields.forEach((ele) => {
        if (ele.coreID != undefined) {
          coreID = ele.coreID;
        }
        if (ele.fieldName == "Type") {
          TypeID = ele.subFolderID;
        }

        var timestamp = Date.parse(ele.fieldValue);

        if (isNaN(timestamp) == false && ele.fieldTypeID == 4) {
          ReqModel[ele.fieldName] = this.datepipe.transform(
            ele.fieldValue,
            'MM/dd/yyyy'
          );
        } else {
          if (ele.fieldName == 'Address') {
            if (ReqModel["Address"] == undefined) {
              let addressFieldValues = "";
              let AddressFieldCollection = element.fields.filter(m => m.fieldName == 'Address' && m.childFieldType == 0 && m.fieldValue != '');
              if (AddressFieldCollection.length > 0) {
                addressFieldValues = addressFieldValues + AddressFieldCollection[0].fieldValue;

                ReqModel[ele.fieldName] = addressFieldValues + " " + element.fields.find(m => m.childFieldType == 3 && m.fieldSet == AddressFieldCollection[0].fieldSet).fieldValue
                  + " " + element.fields.find(m => m.childFieldType == 2 && m.fieldSet == AddressFieldCollection[0].fieldSet).fieldValue
                  + " " + element.fields.find(m => m.childFieldType == 4 && m.fieldSet == AddressFieldCollection[0].fieldSet).fieldValue
              } else {
                ReqModel[ele.fieldName] = '—';
              }
            }
          }
          else
            ReqModel[ele.fieldName] = ele.fieldValue ? ele.fieldValue : '—';
        }
      });
      ReqModel['CoreID'] = coreID;
      ReqModel['IsFavorite'] = favorite;
      ReqModel['paychexID'] = paychexID;
      ReqModel['TypeID'] = TypeID;
      returnList.push(ReqModel);
    });
    return returnList;
  }



  RemoveSelectedFilter(filter) {
    var removefilter = filter;
    var filterID = [];
    filterID.push(removefilter);
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      filterIDList: filterID,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.contactService.RemoveSelectedFilter(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.loaderService.hide();
          this.FilteredfieldsRequestModel = [];
          this.getAllCoreTypeNameFilter();
          this.toastr.success('Filter remove successfully.', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.loaderService.hide();
      }
    });

  }


  getFavoriteCoreList(searchKey: string) {
    this.contactList = [];
    this.contactVm.PageIndex = this.pageModelData.pageIndex;
    this.contactVm.PageSize = this.pageModelData.pageSize;
    this.contactVm.DatabaseID = Number(this.databaseId);
    this.contactVm.OrganizationID = Number(this.organizationId);
    this.contactVm.UserID = this.currentUser.UID;
    this.contactVm.OfficeIDList = this.OfficeIDList;
    this.contactVm.officeID = this.myOfficeID;
    this.contactService.getContactFavoriteList(this.contactVm).subscribe((response) => {
      if (response != undefined) {
        this.ToogleColumnFields = [];
        this.contactFieldColumnToogle = [];
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.totalCount = response.data.totalcount;
          this.contactList = response.data.contacts;//transactions;
          sessionStorage.setItem('contactList', JSON.stringify(response.data.contacts));
          this.Allids = response.data.ids;
          this.contactList.map((e) => {
            let imagepath = (e.imageUrl == null || e.imageUrl == undefined || e.imageUrl == '') ? '' : e.imageUrl;
            if (imagepath != '') {
              if (imagepath.substring(0, 4) == 'http') {
                e.fields.forEach((element) => {
                  if (element.fieldName == 'Name') {
                    element.fieldValue = element.fieldValue + ',' + imagepath;
                  }
                });
              }
            }
            return e;
          });

          this.contactUserListReceived = true;
          let temGridFinalArray = response.data.gridUserSettings.filter((x) => x.fieldName == 'Name');
          let tempgridsettingWithoutName = response.data.gridUserSettings.filter((x) => x.fieldName != 'Name');
          tempgridsettingWithoutName.forEach((element) => {
            temGridFinalArray.push(element);
          });
          response.data.gridUserSettings = temGridFinalArray;
          this.contactFieldList = response.data.gridUserSettings;
          this.contactFieldList.forEach((ele) => {
            if (ele.fieldName == "Status") {
              ele.isDisplay=true;           
            }
          });
          this.contactFieldList = this.contactFieldList.filter((s) => s.isDisplay == true && s.fieldName != 'Image');

          this.contactFieldListNew = response.data.gridUserSettings.filter((s) => s.fieldName != 'Image');

          this.contactListReceived = true;
          this.contactFieldColumnToogle = response.data.gridUserSettings.filter((s) => s.fieldName != 'Image');
          this.setDisplayedColumns();
          this.setListToDisplay();
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
          this.contactList = [];
          this.contactFieldList = [];
          this._returnList = [];
          this.dataSource = new MatTableDataSource();
          this.dataSource.data = [];
          this.dataSource.paginator = null;
          this.dataSource.sort = this.sort;
          this.paginatorTotalLength = 0;
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  getList(searchKey: string) {
    if (this.FilteredfieldsRequestModel.length > 0 && this.FilteredfieldsRequestModel != undefined) {
      return;
    }
    this.contactList = [];
    this.contactVm.FolderId = this.folderID;
    this.contactVm.PageIndex = this.pageModelData.pageIndex;
    this.contactVm.PageSize = this.pageModelData.pageSize;
    this.contactVm.DatabaseID = Number(this.databaseId);
    this.contactVm.OrganizationID = Number(this.organizationId);
    this.contactVm.UserID = this.currentUser.UID;
    this.contactVm.searchKey = this.value.trim();
    this.contactVm.userContactID = Number(sessionStorage.getItem('userContactID'));
    this.contactVm.roleIDList = sessionStorage.getItem('roleIDList').split(',');
    this.contactVm.officeID = this.myOfficeID;
    this.contactVm.OfficeIDList = this.OfficeIDList;
    this.contactVm.isArchived = this.archieved;
    this.loaderService.show();
    this.contactService.getContactList(this.contactVm).subscribe((response) => {
      if (response != undefined) {
        this.ToogleColumnFields = [];
        this.contactFieldColumnToogle = [];
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.isAnyRecordAvailable = response.data.isAnyRecordAvailable;
          this.totalCount = response.data.totalcount;
          this.contactList = this.isAnyRecordAvailable ? response.data.contacts : [];//transactions;
          sessionStorage.setItem('contactList', JSON.stringify(response.data.contacts));
          this.Allids = response.data.ids;
          this.contactList.map((e) => {
            let imagepath = (e.imageUrl == null || e.imageUrl == undefined || e.imageUrl == '') ? '' : e.imageUrl;
            if (imagepath != '') {
              if (imagepath.substring(0, 4) == 'http') {
                e.fields.forEach((element) => {
                  if (element.fieldName == 'Name') {
                    element.fieldValue = element.fieldValue + ',' + imagepath;
                  }
                });
              }
            }
            return e;
          });

          this.contactUserListReceived = true;
          let temGridFinalArray = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((x) => x.fieldName == 'Name');
          let tempgridsettingWithoutName = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((x) => x.fieldName != 'Name');
          this.isAnyRecordAvailable && tempgridsettingWithoutName.forEach((element) => {
            temGridFinalArray.push(element);
          });
          response.data.gridUserSettings = temGridFinalArray;
          this.contactFieldList = response.data.gridUserSettings;
          if(this.contactFieldList.length>0){
            this.contactFieldList.forEach((ele) => {
              if (ele.fieldName == "Status") {
                ele.isDisplay=true;           
              }
            });
          }
          this.contactFieldList = this.isAnyRecordAvailable && this.contactFieldList.filter((s) => s.isDisplay == true && s.fieldName != 'Image');
          this.contactFieldList = this.isAnyRecordAvailable && this.contactFieldList.filter((s) => s.availableOn != 2);
          this.contactFieldList = this.isAnyRecordAvailable && this.contactFieldList.filter((s) => s.rolePermission != 2);

          this.contactFieldListNew = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((s) => s.fieldName != 'Image');

          this.contactListReceived = true;
          this.contactFieldColumnToogle = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((s) => s.fieldName != 'Image');
          this.contactFieldColumnToogle = this.isAnyRecordAvailable && response.data.gridUserSettings.filter((s) => s.rolePermission != 2);
          this.contactFieldColumnToogle = this.isAnyRecordAvailable && this.contactFieldColumnToogle.filter((s) => s.availableOn != 2);
          this.setDisplayedColumns();
          this.setListToDisplay();
          this.loaderService.hide();
        } else {
          this.isAnyRecordAvailable = false;
          this.loaderService.hide();
          this.contactList = [];
          this.contactFieldList = [];
          this._returnList = [];
          this.dataSource = new MatTableDataSource();
          this.dataSource.data = [];
          this.dataSource.paginator = null;
          this.dataSource.sort = this.sort;
          this.paginatorTotalLength = 0;
        }
      } else {
        this.isAnyRecordAvailable = false;
        this.loaderService.hide();
      }
    });
  }

  diplayList: any[] = [];

  setListToDisplay() {
    if (this.contactUserListReceived && this.contactListReceived) {
      this.diplayList = [];
      var favorite: boolean = false;
      for (var user = 0; user < this.contactList.length; user++) {
        let tempUserFields: any[] = [];
        for (var coreField = 0;
          coreField < this.contactFieldList.length;
          coreField++
        ) {
          let fieldFound = false;
          for (var userField = 0; userField < this.contactList[user].fields.length; userField++) {
            if (
              this.contactFieldList[coreField].fieldID ==
              this.contactList[user].fields[userField].fieldID
            ) {
              fieldFound = true;
              tempUserFields.push(this.contactList[user].fields[userField]);
              // break;
            }
            if (userField + 1 == this.contactList[user].fields.length && fieldFound == false) {
              var fieldValue = "";
              if(this.contactFieldList[coreField].fieldName=="Status"){
                var check=[];
                check=this.contactList.filter(x=>x.contactID == this.contactList[user].fields[0].coreID);
                if(check.length>0){
                  fieldValue=check[0].status;
                }else{
                  fieldValue="";
                }
              }
              var ReqModel = {
                fieldID: this.contactFieldList[coreField].fieldID,
                fieldName: this.contactFieldList[coreField].fieldName,
                fieldTypeID: this.contactFieldList[coreField].fieldTypeID,
                fieldTypeName: this.contactFieldList[coreField].fieldTypeName,
                fieldValue: fieldValue,
                transactionID: this.contactList[user].fields[0].coreID,
              };
              tempUserFields.push(ReqModel);
            }
          }
        }
        var _user = {
          fields: tempUserFields,
          transactionID: tempUserFields[0].contactID,
          isFavorite: this.contactList[user].isFavorite,
          paychexID: this.contactList[user].paychexID
        };
        this.diplayList.push(_user);
      }
    }

    this.contactListNew = [];
    this.contactListNew = this.diplayList;

    this._returnList = this.setListForDrogandDrop(this.contactListNew);

    if (this._returnList && this._returnList[0] && this._returnColumns) {
      for (var prop in this._returnList[0]) {
        this._returnColumns.push(prop);
      }
    }

    this.isAnyRecordAvailable && this.contactFieldList.forEach((colunm, index) => {
      colunm.index = index;
      this.displayedColumns[index] = colunm.fieldName;
    });

    this.dataSource = new MatTableDataSource();
    this.dataSource.data = this._returnList;
    this.dataSource.paginator = null;
    this.dataSource.sort = this.sort;
    this.pageIndex = this.pageModelData.pageIndex;
    this.pageSize = this.pageModelData.pageSize;
    this.paginatorTotalLength = this.totalCount;
  }

  clearFilter() {
    this.value = "";
    this.filterText = "";
    this.pageModelData.pageIndex=0;
    this.getList(this.filterText);
  }


  // to filter based on search $$....
  SearchRecord(filterValue) {
    this.filterText = filterValue.trim();
    this.value = this.filterText;
    this.pageModelData.pageIndex=0;
    this.getList(this.filterText);
    return;
  }


  onSubmitColumns(result) {
    this.updateColumnContactVm.UserID = this.currentUser.UID;
    this.updateColumnContactVm.DatabaseID = Number(this.databaseId);
    this.updateColumnContactVm.OrganizationID = Number(this.organizationId);
    this.updateColumnContactVm.officeID = this.myOfficeID;
    this.updateColumnContactVm.OfficeIDList = this.OfficeIDList;
    this.updateColumnContactVm.CustomizationGridUserSetting = result;
    this.contactService.updateContactFieldColumnList(this.updateColumnContactVm).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.close();
          this.getList("");
        }
      }
    });
  }

  CallNextPrevPageData(pageData: PageEvent) {
    this.currentData = pageData;
    this.pageModelData.pageIndex = pageData.pageIndex;
    this.pageModelData.pageSize = pageData.pageSize;
    this.pageModelData.searchValue = this.value.trim();
    this.pageIndex = pageData.pageIndex;
    this.pageSize = pageData.pageSize;
    if (this.Filtername == "All " + this.Module) {
      if (this.selectedfilterList.length > 0) {
        this.FilteredList(this.selectedfilterList);
      } else {
        this.getList(this.value.trim());
      }
    }
    else {
      if (this.selectedfilterList.length > 0) {
        this.FilteredList(this.selectedfilterList);
      } else {
        this.getList(this.value.trim());
      }
    }

  }


  // CallNextPrevPageData(pageData: PageEvent) {
  //   this.currentData = pageData;
  //   this.pageModelData.pageIndex = pageData.pageIndex;
  //   this.pageModelData.pageSize = pageData.pageSize;
  //   this.pageModelData.searchValue = this.value.trim();
  //   this.pageIndex = pageData.pageIndex;
  //   this.pageSize = pageData.pageSize;
  //   if (this.Filtername == "All " + this.Module) {
  //     this.getList(this.value.trim());
  //   }
  //   else {
  //     this.FilteredList(this.selectedfilterList);
  //   }
  // }


  addNew(message) {
    this.addListing = !this.addListing;
  }

  getClose(message) {
    this.addListing = message;
  }

  close() {
    this.dialog.closeAll();
  }

  customizeColumn(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }

  getapplyFilter(message) {
    this.showFilter = !this.showFilter;
  }

  getCloseFilter(message) {
    this.showFilter = message;
    //this.getAllCoreTypeNameFilter();
  }

  getCloseFilterAfterSave(message) {
    this.showFilter = message;
    this.getAllCoreTypeNameFilter();
  }

  getshowRightSidePanel(message) {
    this.showDetail = true;
  }

  getselectedTransactionId(result) {
    this.selectedtransactionId = result;
  }

  getCloseDetail(message) {
    this.showDetail = message;
  }

  CloseAttachToTaskList() {
    this.getList("");   
    this.dialog.closeAll();
  }


}
